import { Directive, ElementRef, inject, OnDestroy, OnInit, output } from '@angular/core';
import { debounce } from '../../lib/debounce';

@Directive({
  selector: '[appSmoothAutoHeight]',
})
export class SmoothAutoHeightDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef) as ElementRef<HTMLElement>;
  height = output<number>();
  private destroyed = false;

  ngOnInit(): void {
    const outputsize = () => this.notify();
    outputsize();
    new ResizeObserver(outputsize).observe(this.el.nativeElement);
  }

  private notify = debounce(() => {
    if (this.destroyed) return;
    try {
      this.height.emit(this.el.nativeElement.scrollHeight);
    } catch {}
  }, 50);

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
